module.exports = __webpack_public_path__ + "img/szr女形象.18c8946b.jpg";